if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      var nameId = this.form.querySelector('[name=id]');
      if (nameId){
        nameId.disabled = false;
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.afteraddtocart();
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    afteraddtocart() {
      document.querySelector('.product-form__submit').classList.add('added');
      document.querySelector('.product-form__submit span').innerHTML = 'Added';
      document.querySelector('.top-btn').classList.add('show');
      document.querySelector('.bottom-btn').classList.add('show');
      var elementPosition = document.querySelector('.addons-tab-wrapper').offsetTop;

      var addtocart_wrapper = document.querySelector('.product-form__wrap');
       if (!addtocart_wrapper.classList.contains('vday')) {
        var popup_status = sessionStorage.getItem("collection_popup_status");
        var soldout_popup = JSON.parse(sessionStorage.getItem("soldout_popup"));
        var soldout_status = soldout_popup?.status;
        console.log({soldout_status})
        if (popup_status !='shown' && soldout_status != 'shown') {
          $('.hover_bkgr_fricc').show();
          $('.hover_bkgr_fricc').addClass("active-popup");
          sessionStorage.setItem("collection_popup_status", "shown");
        }
      }
      
      setTimeout(function() {
        window.scrollTo({
          top: elementPosition - 100, //add your necessary value
          behavior: "smooth"  //Smooth transition to roll
        });
        document.querySelector('.product-form__submit').classList.remove('added');
        document.querySelector('.product-form__submit span').innerHTML = 'Proceed to Checkout';

        var button_sec = document.querySelector('.addtocart-btn-trigger .button');
        button_sec.classList.add('sec-checkout-btn');
        button_sec.classList.remove('disabled');
        button_sec.removeAttribute('disabled');
        var svgElement = button_sec.querySelector('svg');
        document.querySelector('.addtocart-btn-trigger .button span').innerHTML = 'Proceed to Checkout';
        document.querySelector('.product-form__submit').classList.add('sec-checkout-btn');
        if (svgElement) {
          button_sec.removeChild(svgElement);
        }
      }, 1500)
    }
  });
}
